import React, { useContext } from "react";
import { Link } from "react-router-dom";
import Seo from "./Head";
import { CartContext } from "../context/CartContext";
import Loader from "../components/Loader";

const Home = () => {
  window.scrollTo(0, 0);
  const { items, categoriesPromo, categories, isLoading } =
    useContext(CartContext);

  const cantidadDeFotos = 30;
  const fotosInstagram = Array.from(
    { length: cantidadDeFotos },
    (_, i) => `/instagram/instagram%20(${i + 1}).jpeg`,
  );

  const listaPrecios = [
    { nombre: "Armazón promo + antireflejo", precio: "$44.790" },
    { nombre: "Armazón promo + Filtro Azul", precio: "$48.290" },
    { nombre: "Armazón promo + fotocromático", precio: "$79.990" },
    { nombre: "Armazón promo + bifocal desde", precio: "$67.590" },
    { nombre: "Armazón promo + multifocal desde", precio: "$127.890" },
    { nombre: "¡Mandanos tu receta!", precio: "" },
  ];

  const getCategoryThumb = (categoriaNombre) => {
    // Buscamos el primer producto que sea de la categoría, esté activo y tenga stock (> 0)
    const producto = items?.find(
      (i) =>
        i.categoria === categoriaNombre &&
        i.estado === "activo" &&
        Number(i.stock) > 0,
    );

    // Si no encuentra ninguno activo y con stock, busca al menos alguno activo (opcional como respaldo)
    const productoFinal =
      producto ||
      items?.find(
        (i) => i.categoria === categoriaNombre && i.estado === "activo",
      ) ||
      items?.find((i) => i.categoria === categoriaNombre);

    if (!productoFinal || !productoFinal.imagenes) return "/placeholder.jpg";

    try {
      const fotos =
        typeof productoFinal.imagenes === "string"
          ? JSON.parse(productoFinal.imagenes)
          : productoFinal.imagenes;

      if (Array.isArray(fotos) && fotos.length > 0) {
        if (typeof fotos[0] === "object" && fotos[0].url) return fotos[0].url;
        return `https://optimarketok.com.ar/imagenes/${fotos[0]}`;
      }
    } catch (e) {
      console.error(e);
    }

    return "/placeholder.jpg";
  };

  if (isLoading)
    return (
      <div className="loader-container">
        <Loader />
      </div>
    );

  return (
    <>
      <Seo
        title={"Optimarket OK"}
        description={"Recetados, Sol, lentes de contacto"}
        image={`${window.location.origin}/static/media/LogoNuevo.png`}
        pathSlug={window.location.href}
      />

      <div className="nuevoHome container-fluid sinBorde">
        {/* TICKER */}
        <div className="precios-ticker-container">
          <div className="precios-ticker-wrapper">
            {[...listaPrecios, ...listaPrecios].map((item, index) => (
              <div key={index} className="ticker-item">
                <span className="ticker-nombre">{item.nombre}</span>
                <span className="ticker-precio">{item.precio}</span>
                <span className="ticker-separador">|</span>
              </div>
            ))}
          </div>
        </div>

        {/* SECCIÓN PROMO + CARROUSEL */}
        <div className="row promo mt-3 align-items-stretch">
          <div className="col-12 col-md-9">
            <div className="seccion-contenedor h-100">
              <span className="seccion-titulo">PROMO</span>
              <div id="links" className="botones row h-100 m-0 p-2">
                {categoriesPromo?.map((cat) => (
                  <div key={cat.id} className="col-6 col-md-4 mb-3">
                    <Link
                      to={`/categoria/${cat.categoria}/`}
                      className="row promoHome h-100"
                    >
                      <div className="sombraCat w-100">
                        <img
                          src={getCategoryThumb(cat.categoria)}
                          alt={cat.categoria}
                          className="col-12 img-fluid fondoGris"
                          style={{
                            aspectRatio: "800 / 530",
                            objectFit: "cover",
                          }}
                        />
                        <h1 className="textoBajo text-center">
                          {cat.categoria}
                        </h1>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* CARROUSEL CON FLECHAS */}
          <div className="promoCartel col-12 col-md-3">
            <div
              id="carouselPromo"
              className="carousel slide carousel-fade h-100"
              data-bs-ride="carousel"
            >
              <div className="carousel-inner h-100">
                {fotosInstagram.map((src, index) => (
                  <div
                    key={index}
                    className={`carousel-item h-100 ${index === 0 ? "active" : ""}`}
                    data-bs-interval="3000"
                  >
                    <img
                      src={src}
                      alt="Instagram"
                      className="d-block w-100 h-100"
                      style={{ objectFit: "cover" }}
                    />
                  </div>
                ))}
              </div>
              {/* BOTONES DE CONTROL (FLECHAS) */}
              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#carouselPromo"
                data-bs-slide="prev"
              >
                <span
                  className="carousel-control-prev-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Anterior</span>
              </button>
              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#carouselPromo"
                data-bs-slide="next"
              >
                <span
                  className="carousel-control-next-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Siguiente</span>
              </button>
            </div>
          </div>
        </div>

        {/* SECCIÓN OTROS MODELOS */}
        <div className="row promo mt-5">
          <div className="col-12">
            <div className="seccion-contenedor">
              <span className="seccion-titulo">OTROS MODELOS</span>
              <div id="links" className="botones row m-0 p-2">
                {categories?.map((cat) => (
                  <div key={cat.id} className="col-6 col-md-4 mb-3">
                    <Link
                      to={`/categoria/${cat.categoria}/`}
                      className="row promoHome"
                    >
                      <div className="sombraCat">
                        <img
                          src={getCategoryThumb(cat.categoria)}
                          alt={cat.categoria}
                          className="col-12 img-fluid fondoGris"
                          style={{
                            aspectRatio: "800 / 530",
                            objectFit: "cover",
                          }}
                        />
                        <h1 className="textoBajo text-center">
                          {cat.categoria}
                        </h1>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="col-12 text-center">
            <iframe
              title="Nuestro clientes"
              src="https://www.google.com/maps/d/embed?mid=1dZ0FWcKSX_gjDPqcpKT0QCKk1ay7hzI&ehbc=2E312F&noprof=1"
              width="90%"
              height="480"
              style={{ border: 0, borderRadius: "15px" }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
